import createAxios from './api'

const PATH_API = 'csc/v1/'

function ensureTrailingSlash(str) {
  if (str.charAt(str.length - 1) !== '/') {
    return str + '/'
  }
  return str
}

export default {

  async listCredentials(apiUrl, idToken, req) {
    const axios = await createAxios(true, null, idToken)
    const fullurl = ensureTrailingSlash(apiUrl) + PATH_API + 'credentials/list'
    const resp = await axios.post(fullurl, req)
    return resp.data
  },

  async credentialsInfo(apiUrl, idToken, req) {
    const axios = await createAxios(true, null, idToken)
    const fullurl = ensureTrailingSlash(apiUrl) + PATH_API + 'credentials/info'
    const resp = await axios.post(fullurl, req)
    return resp.data
  },

  async authorizeCredential(apiUrl, idToken, req) {
    const axios = await createAxios(true, null, idToken)
    const fullurl = ensureTrailingSlash(apiUrl) + PATH_API + 'credentials/authorize'
    const resp = await axios.post(fullurl, req)
    return resp.data
  },

  async authorizeCredentialExternal(authorizationEndpoint, idToken, req) {
    const axios = await createAxios(true, null, idToken)
    const resp = await axios.post(authorizationEndpoint, req)
    return resp.data
  },

  async getInfo(apiUrl) {
    const axios = await createAxios(false, null, null)
    const req = {}
    const fullurl = ensureTrailingSlash(apiUrl) + PATH_API + 'info'
    const resp = await axios.post(fullurl, req)
    return resp.data
  }

}
